import { TextEditor } from '@movingimage-evp/mi-ui-component-library';
import { useTranslation } from 'react-i18next';

import styles from './compliance-link-editor.module.css';

type Props = {
  language: string;
  content?: string;
  disabled?: boolean;
  refreshKey?: string | number; // Change this to force a refresh of the editor
  onChange: (content: string) => void;
};

export function ComplianceLinkEditor({ language, content, disabled, refreshKey = 0, onChange }: Props) {
  const { t } = useTranslation();

  const placeholder = `${t('manager.channelSettings.compliance.editor.renderPlaceholder1')} ${t(
    'manager.channelSettings.compliance.editor.renderPlaceholder2'
  )}, ${t('manager.channelSettings.compliance.editor.renderPlaceholder3')}, ${t(
    'manager.channelSettings.compliance.editor.renderPlaceholder4'
  )}`;

  return (
    <div className={styles.wrapper}>
      <TextEditor
        key={refreshKey}
        variant="link-only"
        value={content}
        data-testid={`compliance-rich-text-editor-${language}`}
        disabled={disabled}
        className={styles.richTextEditor}
        editorOptions={{ autofocus: 'end' }}
        placeholder={placeholder}
        onChange={onChange}
      />
    </div>
  );
}
